var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadScript)?_c('script',{attrs:{"async":"","data-test":"google-reviews-script","src":"//apis.google.com/js/platform.js?onload=renderBadge","type":"application/javascript"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }